import RejectedResult from './RejectedResult'
import ReasonSelection from './ReasonSelection'
import { FC, useState } from 'react'
import { ProposalReviewView } from '@/types/management.types'

interface Props {
  setView?: (view: ProposalReviewView) => void
}
const RejectedProposalContent: FC<Props> = ({ setView }) => {
  const [cancelConfirmed, setCancelConfirm] = useState<boolean>(false)

  const handleCancel = () => {
    setView?.('adjustments')
  }

  const handleConfirm = (reason: string, customReason?: string) => {
    console.log('Selected reason:', reason)
    console.log('Custom reason (if any):', customReason)
    setCancelConfirm(true)
    // Handle confirm action
  }
  const handleFinish = () => {
    setView?.('pending')
  }

  return (
    <div className="w-full flex flex-1 items-center">
      {cancelConfirmed ? (
        <RejectedResult onFinish={handleFinish} />
      ) : (
        <ReasonSelection onCancel={handleCancel} onConfirm={handleConfirm} />
      )}
    </div>
  )
}

export default RejectedProposalContent
